import { NgModule } from '@angular/core';

import { DocumentUrlPipe } from './document.url.pipe';
import { StaffPipe } from './staff.pipe';
import { FilterMarkedForDeletion } from './filter.marked.for.deletion.pipe';
import { SanitizePipe } from './sanitize.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { SiteconfigtranslationPipe } from './siteconfigtranslation.pipe';
import { SiteMenuDisplaynamePipe } from './site-menu-displayname.pipe';
import { ClientSettingsValuePipe } from './client-settings-value.pipe';
import { SiteConfigurationValuePipe } from './site-configuration-value.pipe';
import { MoneyFormatterPipe } from './money-formatter.pipe';
import { HaveClaimPipe } from './have-claim.pipe';
import { SiteMenuTranslationPipe } from './site-menu-translation.pipe';

@NgModule({
    declarations: [
        DocumentUrlPipe,
        StaffPipe,
        SanitizePipe,
        FilterMarkedForDeletion,
        DateFormatPipe,
        SiteconfigtranslationPipe,
        SiteMenuDisplaynamePipe,
        ClientSettingsValuePipe,
        SiteConfigurationValuePipe,
        MoneyFormatterPipe,
        HaveClaimPipe,
        SiteMenuTranslationPipe
    ],
    imports: [
    ],
    providers: [],
    exports: [
        DocumentUrlPipe,
        StaffPipe,
        SanitizePipe,
        FilterMarkedForDeletion,
        DateFormatPipe,
        SiteconfigtranslationPipe,
        SiteMenuDisplaynamePipe,
        ClientSettingsValuePipe,
        SiteConfigurationValuePipe,
        MoneyFormatterPipe,
        HaveClaimPipe,
        SiteMenuTranslationPipe
    ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/pipes/pipes.module.ts